<template>
  <div class="table table-responsive base-table mb-0" :style="{height : maxHeight+`px`,width : maxWidth+`%`}">
    <table class="table table-bordered table-sm text-center small sticky-header table-hover">
      <thead>
      <slot name="table-header" />
      </thead>
      <tbody>
      <tr v-if="loading">
        <td :colspan="loaderColspan">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span> Loading...</span>
        </td>
      </tr>
      <slot v-else name="table-body" />
      </tbody>
      <tfoot>
      <slot name="table-footer" />
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  name: 'BaseTable',

  /** mixins **/
  mixins: [],

  /** props **/
  props: {
    maxHeight: {
      type: Number,
      default: 500,
    },

    maxWidth: {
      type: Number,
      default: 100,
    },

    loaderColspan: {
      type: Number,
      default: 1,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  /** data **/
  data() {
    return {};
  },

  /** methods**/
  methods: {},

  /**  computed  **/
  computed: {},

  /** mounted **/
  mounted() {
    $('table tfoot').each(function() {
      $(this).insertAfter($(this).siblings('thead'));
    });
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
  },

};
</script>

<style scoped lang="scss">

</style>
